import Activity from './activity';

const ActivitiesSection = () => {
  const activities = [
    {
      url: './activities/activity-12.webp',
      title: 'Hiking with Infineon Colleagues',
    },
    {
      url: './activities/activity-11.webp',
      title: 'Talk @FSR AI in BTU Cottbus',
    },
    {
      url: './activities/activity-10.webp',
      title: 'First Day @Infineon Technologies',
    },
    {
      url: './activities/activity-9.webp',
      title: 'Meetup @Employed.world',
    },
    {
      url: './activities/activity-5.webp',
      title: 'UX Meetup @FOF Dubai',
    },
    {
      url: './activities/activity-2.webp',
      title: 'Anniversary @Diamond Developers',
    },
    {
      url: './activities/activity-3.webp',
      title: 'Onboarding @TSC Dubai',
    },
    {
      url: './activities/activity-4.webp',
      title: 'UX Meetup @FOF Dubai',
    },
    {
      url: './activities/activity-7.webp',
      title: 'Le Mans Series @Dubai Autodrome',
    },
    {
      url: './activities/activity-6.webp',
      title: 'Team Meetup @Diamond Developers',
    },
    {
      url: './activities/activity-1.webp',
      title: 'Joining @Diamond Developers',
    },
    {
      url: './activities/activity-8.webp',
      title: 'GSE @Cobblestone Dubai',
    },
  ];

  return (
    <div className="flex gap-4 pt-2 overflow-x-scroll px-4">
      {activities.map((activity, index) => (
        <Activity
          url={activity.url}
          title={activity.title}
          className="w-72 h-72 flex-none"
        />
      ))}
    </div>
  );
};

export default ActivitiesSection;
